// extracted by mini-css-extract-plugin
export default {"main":"RemoveModal_main__lEccM","header":"RemoveModal_header__WPaj+","closeBtn":"RemoveModal_closeBtn__pYHNa","copy":"RemoveModal_copy__qdI1k","actions":"RemoveModal_actions__bG1fZ"};